import React, { useCallback } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const PlaybackDetails = React.lazy(() => loadComponent('traiwiss', 'PlaybackDetails'))

export function PlaybackDetailsRoute() {
    const params = useParams()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const onSave = useCallback(() => {
        navigate('/')
    }, [navigate])

    return (
        <RouteContainer>
            <PlaybackDetails
                trainingId={params._id}
                initialTrainingVideoId={searchParams.get('video') ?? undefined}
                onSave={onSave}
            />
        </RouteContainer>
    )
}
